export default __webpack_public_path__ + "static/media/KOD0037-min.1d53e796.webp";